import { Component, Inject, OnInit} from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-addtouchestatustype',
  templateUrl: './addtouchestatustype.component.html',
  styleUrls: ['./addtouchestatustype.component.scss'] 
})

export class AddToucheStatusTypeComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;    
  formDialog: FormGroup; 
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;
  statusList:any=[]=[];
  selectedtouchStatusID:number=0;
  ShowNoRecordFoundStatus:boolean=false;

  constructor(public dialogRef: MatDialogRef<AddToucheStatusTypeComponent>,  
    private formBuilder: FormBuilder,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
  }  
  
  ngOnInit(): void {  
    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('statusName', this.formBuilder.control('')); 
    this.GetAllToucheStatus("");  
   }     
       


   AddStatusName(data) {
    //return;
     let ReqModel = {
      touchStatusName: data.statusName.trim(),
      touchTypeID:Number(this.data.touchTypeID),
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID
    }
    this.spinner=true;
    this.showDisabled=true;
    this.formDialog.markAsPristine();
    this.coreService.addTouchStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner=false;
        if (this.responseHolder.data.isSuccess == true) {
          this.formDialog.reset();
          this.dialogRef.close(this.responseHolder.data.id);
          this.toastr.success('Status added successfully.', '', {
            timeOut: 2000,
          });     
        }else{
          this.spinner=false;
          this.toastr.warning('Already exist.', '', {
            timeOut: 2000,
          });         
        }
      }else{
        this.spinner=false;
      }
    });
  }

   closeAddTouchType() {
    this.formDialog.reset();    
    this.dialogRef.close();
  }

  GetAllToucheStatus(searchKey) {   
     let ReqModel = {
      touchTypeID:Number(this.data.touchTypeID),
      searchKey: searchKey,
      userId: this.currentUser.UID, 
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),     
      officeID:this.myOfficeID   
    }   
    this.coreService.getAllToucheStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;      
        this.statusList =  this.responseHolder.data;
        if(this.statusList!=null){
          this.ShowNoRecordFoundStatus = false;
        }
        else {
          this.ShowNoRecordFoundStatus = true;
        } 
      }else{
      
      }
    });
  }

  showDisabled:boolean=true;

  SelectStatus(data){
    this.selectedtouchStatusID = data.touchStatusID;
    this.formDialog.controls['statusName'].setValue(data.touchStatusName);
    this.showDisabled=false;
  }

  onSearchChange(searchValue: string): void {   
    if(searchValue==""){
      this.selectedtouchStatusID=0;
      this.showDisabled=true;
      this.GetAllToucheStatus("");
    }else{
      this.GetAllToucheStatus(searchValue);
      this.showDisabled=false;
    }
  }

}
